import PropTypes from "prop-types";
import React, { useState, useCallback } from "react";
import { ContainerTabela, Estilos, TituloTabela } from "../styles/styled";
import ModalDetalhes from "../../Components/Modal/ModalDetalhes";
import Tabela from "./Tabela";
import ModalAtendimentos from "../../Components/ModalAtendimentos/ModalAtendimentos";

const TableTurma = ({
  dadosTurma,
  status,
  data,
  bim,
  tipop,
  tipom,
  setMediaTurma,
  setMediaSerieFilial,
  setMediaSerieOrg,
  perfil
}) => {
  const [current, setCurrent] = useState();
  const [visible, setVisible] = useState(false);
  const [visibleAtendimentos, setVisibleAtendimentos] = useState(false);
  const [currentRA, setCurrentRA] = useState();

  const handleClick = useCallback((params, visibility) => {
    setCurrent(params);
    setVisible(visibility);
  }, []);

  const handleClickAtendimento = useCallback((params, visibility) => {
    setCurrentRA(params);
    setVisibleAtendimentos(visibility);
  }, []);

  const Titulo = ({ texto }) => {
    return <TituloTabela>{texto}</TituloTabela>;
  };

  return (
    <>
      <Estilos>
        <ContainerTabela>
          <Titulo texto="Alunos com baixo rendimento" />
          <Tabela
            dadosTurma={dadosTurma}
            handleClick={handleClick}
            status={status}
            setMediaTurma={setMediaTurma}
            setMediaSerieFilial={setMediaSerieFilial}
            setMediaSerieOrg={setMediaSerieOrg}
            setVisibleAtendimentos={setVisibleAtendimentos}
            handleClickAtendimento={handleClickAtendimento}
            perfil={perfil}
          />
        </ContainerTabela>
      </Estilos>
      <ModalDetalhes
        visible={visible}
        setVisible={handleClick}
        current={current}
        data={data}
        bim={bim}
        tipop={tipop}
        tipom={tipom}
        perfil={perfil}
      />
      <ModalAtendimentos
        Registro={currentRA}
        visibleAtendimentos={visibleAtendimentos}
        setVisibleAtendimentos={setVisibleAtendimentos}
      />
    </>
  );
};
TableTurma.propTypes = {
  registros: PropTypes.array,
};
export default TableTurma;
